import toastr from 'toastr';

export const showSucessToast = message => {
    toastr.success(message);
};

export const showInfoToast = message => {
    toastr.info(message);
};

export const showErrorToast = message => {
    toastr.error(message);
};

export const showNetworkErrorToast = _message => {
    toastr.error('Please check your Internet connection ');
};
